import React from "react";
import { useGetTimes } from "../../hooks";
import { WeekDayWrapper, ColumnHead } from "../StyledComponents";
import TimeCell from "./TimeCell";

const WeekDayTemplate = () => {
    const times = useGetTimes(new Date());

    return (
        <WeekDayWrapper>
            <ColumnHead>
                <div />
            </ColumnHead>
            {times.map((time) => (
                <TimeCell
                    key={time.getTime()}
                    time={time}
                    isConsultation={false}
                    template
                ></TimeCell>
            ))}
        </WeekDayWrapper>
    );
};

export default React.memo(WeekDayTemplate);
